module.exports = __webpack_public_path__ + "/images/shop/icon/logo_kfz24.svg";